/* eslint-disable jsx-a11y/no-distracting-elements */
import React from "react";
import Navbar from "partials/navbar/navbar";
import styles from "./layout.module.scss";
import { ERCText } from "components/text";
// import Footer from "partials/footer/footer";
import { Footer } from "partials/footer/Footer";
import { Link, useNavigate } from "react-router-dom";
// import { useLocation } from 'react-router-dom';

const Layout = ({
  children,
  mqcolor = "#00296B",
  footerColor,
  navButtonColor,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.body}>
      <div className={styles.header}>
        <div className={styles.info} style={{ background: mqcolor }}>
          <marquee width={"30%"} direction="left" loop="">
            <ERCText color={"white"} size="12px">
              Unlimited videos and courses for students from various classes.
            </ERCText>
          </marquee>
          <ERCText isLink underline color={"white"} size="12px" onClick={()=> navigate('/tour')}>
            <Link to={'/tour'}>Tour Lagos</Link>
          </ERCText>
        </div>
      </div>
      <Navbar navButtonColor={navButtonColor} />
      <div className={styles.layoutchildren}> {children}</div>

      <Footer footerColor={footerColor} />
    </div>
  );
};

export default Layout;
